import React from 'react';
import { Box, Typography } from '@mui/material';

import EmailForm from 'src/pages/QueryPages/QueryProfile/components/EmailForm';
import PropTypes from 'prop-types';

const EmailExpertTab = ({ pitch, query, expert }) => (
  <Box sx={{ p: 2 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>
      Email to Expert
    </Typography>
    {query?.status === 'draft' ? (
      <EmailForm
        pitch={pitch}
        deadline={query?.dueDate}
        leadID={query?.leads?.find((lead) => lead.expertID === expert?.id)?.id}
        query={query}
        expert={expert}
      />
    ) : (
      <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
        {pitch}
      </Typography>
    )}
  </Box>
);

EmailExpertTab.propTypes = {
  pitch: PropTypes.string.isRequired,
  query: PropTypes.shape({
    status: PropTypes.string,
    dueDate: PropTypes.string,
    leads: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        expertID: PropTypes.number,
      })
    ),
  }).isRequired,
  expert: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default EmailExpertTab;
